import { English } from "./Languages/English";
import { Dutch } from "./Languages/Dutch";
import { LanguageInterface } from "./LanguageInterface";

class LanguageContainer {
  protected defaultIso: string = "nl-NL";
  protected hash: {
    [key: string]: LanguageInterface;
  } = {};

  constructor(public languages: LanguageInterface[]) {
    // Set all the languages to hash for o(1) lookup.
    this.languages.forEach((language) => {
      this.hash[language.iso] = language;
    });
  }

  public resolve(iso: string): LanguageInterface {
    // If we don't have this iso code yet, return English as default.

    if (this.hash.hasOwnProperty(iso) === false) {
      return this.hash[this.defaultIso];
    }

    return this.hash[iso];
  }

  public all(): LanguageInterface[] {
    return this.languages;
  }
}

export default new LanguageContainer([new English(), new Dutch()]);
